import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const KEY = 'parseeker-event-return';
const TTL = 10 * 60 * 1000;
export const safeEventReturn = value => typeof value === 'string' && /^\/events\/[A-Za-z0-9_-]+$/.test(value) ? value : null;
export const safeWalletReturn = value => typeof value === 'string' && /^\/onboarding\/wallet(?:\?(?:session_id=cs_[A-Za-z0-9_]{5,250}|cancelled=1))?$/.test(value) ? value : null;
export const safeCourseReturn = value => typeof value === 'string' && /^\/proshop(?:\/(?:register|payouts(?:\?stripe=(?:return|refresh))?|dashboard(?:\/(?:overview|bookings|pins|promotions|tournaments|connect|settings|assistance|financials))?))?$/.test(value) ? value : null;
export const safeBookingReturn = value => value === '/book' ? value : null;
const safeAuthReturn = value => safeEventReturn(value) || safeWalletReturn(value) || safeCourseReturn(value) || safeBookingReturn(value);
export const clearEventReturn = () => { try { sessionStorage.removeItem(KEY); } catch {} };
export const rememberEventReturn = path => {
  clearEventReturn();
  if (!safeAuthReturn(path)) return;
  try { sessionStorage.setItem(KEY, JSON.stringify({ path, savedAt: Date.now() })); } catch {}
};
export const consumeEventReturn = () => {
  try {
    const saved = JSON.parse(sessionStorage.getItem(KEY));
    clearEventReturn();
    const age = Date.now() - saved?.savedAt;
    return age >= 0 && age <= TTL ? safeAuthReturn(saved?.path) : null;
  } catch { clearEventReturn(); return null; }
};
// All existing sign-in methods already finish at /home. Keep their session logic intact.
export const useEventReturn = (user, loading, ready = true) => {
  const location = useLocation();
  const navigate = useNavigate();
  useEffect(() => {
    if (loading || !ready || !user || location.pathname !== '/home') return;
    const path = consumeEventReturn();
    if (path) navigate(path, { replace: true });
  }, [user, loading, ready, location.pathname, navigate]);
};